module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow3-8481446beb8e31f428d09eb79aecd561.svg";